<div class="p-4 space-y-4">

  <!-- Header informativo -->
  <div class="flex items-center gap-3 bg-blue-50 border border-blue-200 p-3 rounded-lg">
    <i class="pi pi-info-circle text-blue-500 text-xl"></i>
    <div>
      <div class="font-semibold text-gray-800">
        Configuración temporal activa
      </div>
      <div class="text-sm text-gray-600">
        Actualmente estás trabajando con una tienda diferente a tu configuración original.
      </div>
    </div>
  </div>

  <!-- Comparación -->
  <div class="grid grid-cols-2 gap-4">

    <!-- Configuración actual -->
    <div class="border rounded-lg p-4 bg-green-50 border-green-200">
      <p-tag severity="success" value="Activa"></p-tag>


      <div class="text-lg font-semibold text-gray-800">
        {{ store?.pais }}-{{ store?.puntoVenta }}
      </div>

      <div class="text-sm text-gray-600">
        {{ store?.descripcionPuntoVenta }}
      </div>
    </div>

    <!-- Configuración original -->
    <div class="border rounded-lg p-4 bg-gray-50 border-gray-200">
      <p-tag severity="secondary" value="Original"></p-tag>


      <div class="text-lg font-semibold text-gray-800">
        {{ store?.paisOriginal }}-{{ store?.puntoVentaOriginal }}
      </div>

      <div class="text-sm text-gray-600">
        {{ store?.descripcionPuntoOriginal }}
      </div>
    </div>

  </div>

  <!-- Acción -->
  <div class="flex justify-end pt-3">
    <p-button
      icon="pi pi-undo"
      class="p-button-warning"
      label="Revertir configuración"
      (click)="revertirConfiguracion()"
    ></p-button>
  </div>

  @if (errorMensaje) {
    <p-tag severity="danger" [value]=" errorMensaje "></p-tag>
  }


</div>
